// src/routes/AppRouter.jsx

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Navbar from "../components/Navbar";
import Search from "../pages/Search";
import Add from "../pages/Add";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import ProtectedRoute from "../components/ProtectedRoute";
import Groups from "../pages/Groups";
import Warranty from "../pages/Warranty";

// Wrapper to use hooks like useLocation inside Router
const AppRouter = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

const AppRoutes = () => {
  const { currentUser } = useAuth();
  const location = useLocation();

  // Check if the current route should show the navbar
  const shouldShowNavbar = () => {
    const publicRoutes = ['/login', '/register', '/forgot-password', '/warranty'];
    return !publicRoutes.includes(location.pathname);
  };

  return (
    <>
      {shouldShowNavbar() && <Navbar />}
      <Routes>
        {/* Public routes */}
        <Route
          path="/login"
          element={!currentUser ? <Login /> : <Navigate to="/" />}
        />
        <Route
          path="/forgot-password"
          element={!currentUser ? <ForgotPassword /> : <Navigate to="/" />}
        />
        <Route path="/warranty" element={<Warranty />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Search key={location.key} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add"
          element={
            <ProtectedRoute>
              <Add key={location.key} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/groups"
          element={
            <ProtectedRoute>
              <Groups />
            </ProtectedRoute>
          }
        />
        
        {/* Redirect unknown paths */}
        <Route
          path="*"
          element={<Navigate to={currentUser ? "/" : "/login"} replace />}
        />
      </Routes>
    </>
  );
};

export default AppRouter;
